<template>
    <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">{{title}}</h2>
        <form ref="form" class="">
            <div class="uk-margin uk-grid">
                <label for="craft-name" class="uk-form-label uk-width-1">Craft Name</label>

                <div class="uk-form-controls uk-width-2-3">
                    <input id="craft-name" type="text" name="name" class="uk-input" v-model="name" />
                </div>
            </div>
            <div class="uk-grid">
                <div class="uk-form-label uk-width-1-2">Craft Code</div>
                <div class="uk-form-label uk-width-1-4">Hourly Rate</div>
                <div class="uk-width-1-4"></div>
            </div>
            <div v-for="(payCode, index) in payCodes" class="uk-grid uk-margin-small-top uk-margin-small-bottom">
                <div class="uk-form-controls uk-width-1-2">
                    <input type="text" class="uk-input" v-model="payCode.code" />
                </div>
                <div class="uk-form-controls uk-width-1-4">
                    <input type="text" class="uk-input" v-model="payCode.payrate" />
                </div>
                <div class="uk-width-1-4 uk-text-left uk-padding-small" style="padding-bottom: 0;padding-top: 8px;cursor: pointer;" @click="dropCode(index)">
                    <i class="far fa-trash-alt"></i>
                </div>
            </div>
            <a class="standard-text" @click="addCraftCode">
                <i class="fas fa-plus-circle"></i> Add Additional Craft Code
            </a>
			<div class="uk-grid uk-margin-small-top uk-margin-small-bottom">
				<div class="uk-width-1-2">
					<div class="uk-form-label">Craft Category</div>
					<select class="uk-select" v-model="selectedCraftCategory">
						<option :value="null"></option>
						<option v-for="category in this.craftCategories" :value="category.id">{{ category.name }}</option>
					</select>
				</div>
			</div>
            <div class="divider uk-width-3-4 uk-margin-medium-top uk-margin-medium-bottom"></div>
            <div class="uk-grid uk-margin-small-top uk-margin-small-bottom">
                <div class="uk-width-1-2">
                    <div class="uk-form-label">Required Certifications</div>
                    <select class="uk-select" v-model="selectedCert">
                        <option v-for="cert in this.availableCerts" :value="cert.id">{{ cert.name }}</option>
                    </select>
                    <div v-if="certs.length > 0" class="list-box uk-margin-small-top">
                        <div v-for="cert in certs" class="list-box-item">
                            {{ cert.name }}
                            <i class="far fa-trash-alt" @click="dropCert(cert.id)"></i>
                        </div>
                    </div>
                </div>
                <div class="uk-width-1-2">
                    <div class="uk-form-label">Required Trainings</div>
                    <select class="uk-select" v-model="selectedTraining">
                        <option v-for="training in this.availableTrainings" :value="training.id">{{ training.name }}</option>
                    </select>
                    <div v-if="trainings.length > 0" class="list-box uk-margin-small-top">
                        <div v-for="training in trainings" class="list-box-item">
                            {{ training.name }}
                            <i class="far fa-trash-alt" @click="dropTraining(training.id)"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-form-label">Ratings</div>
            <div v-for="(cat, index) in ratingCategories" class="uk-grid uk-margin-small-top uk-margin-small-bottom">
                <div class="uk-width-1-2">
                    <input type="text" class="uk-input" v-model="cat.name" />
                </div>
				<div class="uk-width-1-4">
					<label class="uk-form-label">
						<input class="uk-checkbox" type="checkbox" v-model="cat.is_optional" />
						Optional
					</label>
				</div>
                <div class="uk-width-1-4 uk-text-left uk-padding-small" style="padding-bottom: 0;padding-top: 8px;cursor: pointer;" @click="dropRating(index)">
                    <i class="far fa-trash-alt"></i>
                </div>

            </div>
            <a class="standard-text" @click="addRating">
                <i class="fas fa-plus-circle"></i> Add Additional Rating Criteria
            </a>
            <div class="uk-margin-large-bottom"></div>
        </form>
        <button class="uk-button uk-button-primary uk-modal-close" type="button" @click="submitForm()">Finish</button>
        <button class="uk-button uk-button-tertiary uk-modal-close" type="button" @click="cancel()">Cancel</button>
    </div>
</template>
<script>
    export default {

        props: {
            title:{
                type: String,
                default: 'Craft'
            },
            post:{
                type:String,
                default: '/api/craft/save'
            },
            table:{
                type: String,
                default: null
            },
            get:{
                type:String,
                default: '/api/craft/get/'
            },
            getDefaultCrafts:{
                type:String,
                default: '/api/settings/default-categories'
            }
        },

        data(){
            return {
                id:null,
                name:"",
                availableCerts:[],
                availableTrainings:[],
                certs:[],
                trainings:[],
                selectedCert:"",
                selectedTraining:"",
                ratingCategories:[{
                    id:null,
                    name:"",
					is_optional:false
                }],
                defaultCategories:[],
                payCodes:[
                    {
                        id:null,
                        code:"",
                        payrate:null,
                    }
                ],
				craftCategories:[],
				selectedCraftCategory: null
            }
        },

        mounted(){
            this.loadCertifications();
            this.loadTrainings();
			this.loadCraftCategories();

            axios.get(this.getDefaultCrafts)
                .then((pack) => this.setDefaultCategories(pack),(pack) => this.setDefaultCategories(pack));
        },

        methods: {
            submitForm() {
                let data = new FormData();
                let uri = this.post;
                if(this.id !== null){
                    uri = this.ensureEndingSlash(uri) + this.id.toString();
                }
                data.append("name", this.name);
                data.append("pay_codes", JSON.stringify(this.payCodes));
                data.append("certs", JSON.stringify(this.certs));
                data.append("trainings", JSON.stringify(this.trainings));
                data.append("rating_categories", JSON.stringify(this.ratingCategories));
                data.append("skill_category_id", this.selectedCraftCategory);
                axios.post(uri, data)
                    .then(() => this.updateForm(),() => this.updateForm());
            },
            cancel() {
                this.clearForm();
            },
            updateForm(){
                this.clearForm();
                if(this.table){
                    this.$root.$refs[this.table].startSearch();
                }
            },
            clearForm(){
                this.id = null;
                this.name = "";
                this.certs = [];
                this.trainings = [];
                this.selectedCert = "";
                this.selectedTraining = "";

                this.payCodes = [
                    {
                        id:null,
                        code:"",
                        payrate:null,
                    }
                ];

                this.useDefaultCategories();
            },
            loadForm(id){
                this.id = id;
                axios.get(this.ensureEndingSlash(this.get) + id).then((pack) => this.updateFormData(pack))
					.catch(() => {});
            },
            updateFormData(pack){
                let data = pack.data.data;
                this.name = data.name;
                this.certs = data.certifications;
                this.trainings = data.trainings;
                this.crafts = data.trainings;
                this.ratingCategories = data.ratingCategories;
                this.payCodes = data.payCodes;
				this.selectedCraftCategory = data.skill_category_id;

                if(this.ratingCategories.length == 0){
                    this.useDefaultCategories();
                }
            },
            useDefaultCategories(){
                this.ratingCategories = [];
                for(let i = 0; i < this.defaultCategories.length; ++i){
                    this.ratingCategories.push({
                        id:null,
                        name: this.defaultCategories[i].name,
                        is_optional: this.defaultCategories[i].is_optional,
                    });
                }

                if(this.ratingCategories.length < 1){
                    this.ratingCategories.push({
                        id:null,
                        name: "",
                        is_optional: false,
                    });
                }
            },
            ensureEndingSlash(str){
                let lastChar = str.substr(str.length - 1);
                if(lastChar != "/"){
                    return str + "/";
                }
                return str;
            },
            addCraftCode(){
               this.payCodes.push({
                   id:null,
                   code:"",
                   payrate:null
               });
            },
            addRating(){
                this.ratingCategories.push({
                    id:null,
                    name:"",
                    is_optional: false
                });
            },
            dropCode(i){
                this.payCodes.splice(i, 1);
            },
            dropCert(id){
                for(let i = 0; i < this.certs.length;++i){
                    if(this.certs[i].id == id){
                        this.certs.splice(i, 1);
                        break;
                    }
                }
            },
            dropTraining(id){
                for(let i = 0; i < this.trainings.length;++i){
                    if(this.trainings[i].id == id){
                        this.trainings.splice(i, 1);
                        break;
                    }
                }
            },
            dropRating(i){
                this.ratingCategories.splice(i, 1);
            },
            loadCertifications(){
                axios.get("/api/certs/list/all?sort=name&dir=asc").then((pack) => this.updateAvailableCerts(pack))
					.catch(() => {});
            },
            updateAvailableCerts(pack){
                if(pack.data.success){
                    this.availableCerts = pack.data.data;
                }
            },
            loadTrainings(){
                axios.get("/api/training/list/all?sort=name&dir=asc").then((pack) => this.updateAvailableTrainings(pack))
					.catch(() => {});
            },
            updateAvailableTrainings(pack){
                if(pack.data.success){
                    this.availableTrainings = pack.data.data;
                }
            },
            setDefaultCategories(pack){
                if(pack.data.success){
                    this.defaultCategories = pack.data.data;
                    this.useDefaultCategories();
                }
            },
			loadCraftCategories(){
				axios.get("/api/requisition/craft/categories").then((pack) => this.updateCraftCategories(pack))
					.catch(() => {});
			},
			updateCraftCategories(pack){
				if(pack.data.success){
					this.craftCategories = pack.data.data;
				}
			},
        },

        watch:{
            selectedCert(){
                //do not add if already exists
                for(let i = 0; i < this.certs.length;++i){
                    if(this.certs[i].id == this.selectedCert){
                        return;
                    }
                }
                for(let i = 0; i < this.availableCerts.length;++i){
                    if(this.availableCerts[i].id == this.selectedCert){
                        this.certs.push(this.availableCerts[i]);
                        break;
                    }
                }

            },
            selectedTraining(){
                //do not add if already exists
                for(let i = 0; i < this.trainings.length;++i){
                    if(this.trainings[i].id == this.selectedTraining){
                        return;
                    }
                }
                for(let i = 0; i < this.availableTrainings.length;++i){
                    if(this.availableTrainings[i].id == this.selectedTraining){
                        this.trainings.push(this.availableTrainings[i]);
                        break;
                    }
                }
            }
        }

    }
</script>
<style scoped>
    .uk-grid > *{
        padding-left: 2vw;
    }
    .list-box{
        border: thin solid #707070;
    }
    .list-box-item{
        padding: 5px;
        position: relative;
    }
    .list-box-item i{
        position: absolute;
        right: 5px;
        top: 8px;
    }
</style>
